<div tabindex="-1" style="display: block;" aria-modal="true">
	<div class="modal-content">
		<div class="modal-header d-flex align-items-center">
			<h5 class="modal-title"> Edit Field Options </h5>
			<button type="button" class="btn btn-icon" data-bs-dismiss="modal" aria-label="Close" (click)="confirmClose()"
				tabindex="-1"><i class="fal fa-times"></i></button>
		</div>
		<div class="d-flex align-items-center justify-content-center">
			<div class="loading" *ngIf="loading"></div>
		</div>
		<div class="py-3" *ngIf='errorMessage'>
			<div class="error">
				<i class="fas fa-exclamation pe-2"></i> {{ message }}
				<i class="far fa-times ms-auto" (click)="this.errorMessage = false"></i>
			</div>
		</div>
		<div *ngIf="!loading">
			<ng-container *ngIf="isReviewer">
			<wre-edit-reviewer [field]="field"></wre-edit-reviewer>
			</ng-container>
			<ng-container *ngIf="!isReviewer">
				<wre-edit-field [field]="field" 
				(closeModalEvent)="closeModal()" 
				(errorEvent)="handleError($event)"></wre-edit-field>
			</ng-container>
		</div>
		
		<div class="modal-footer">
			<div footer>
				<div class="row">
					<div class="col d-flex justify-content-end">
						<button type="button" class="btn wre-btn btn-secondary" data-bs-dismiss="modal"
							(click)="confirmClose()">Cancel</button>
						<button type="button" class="btn wre-btn btn-primary ms-3" data-bs-dismiss="modal" (click)="saveChanges()" [disabled]="isDisabled">
							Save Changes </button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
